import { Outlet } from "react-router-dom"
import { useState } from "react";
import { AdminSettingsSidebar } from "./AdminSettingsSidebar";
import DeletePopup from "../../components/DeletePopup";
import { ConfirmPopup } from "../../components/ConfirmPopup";
import { UserProfile } from "../userProfile/UserProfile";

export const AdminSettingsLayout = () => {
    const [fullScreen, setFullScreen] = useState<boolean>(true);

    const handleScreen = () => {
        setFullScreen(!fullScreen);
    }

    return (
        <div className="flex bg-[#edf4fd]">
            <AdminSettingsSidebar
                handleScreen={handleScreen}
            />

            <div className={`${fullScreen ? 'w-[calc(100%-224px)]' : 'w-[calc(100%-50px)]'} h-max overflow-auto`}>
                <Outlet />
                <DeletePopup />
                <ConfirmPopup />
                <UserProfile />
            </div>
        </div>
    )
}